export enum AppRouting {
  SignUp = 'signup',
  Login = 'login',
  ForgotPassword = 'forgot-password',
  SetPassword = 'set-password',
  ResetPassword = 'reset-password',
  Mobile = 'mobile',
  Overview = 'overview',
  Products = 'products',
  Usage = 'usage',
  TopUp = 'top-up',
  DataOutsideEu = 'data-ouside-eu',
  PremiumWallet = 'premium-wallet',
  ChangeSubscription = 'change-subscription',
  AddSubscription = 'add-subscription',
  Prolongation = 'prolongation',
  Invoices = 'invoices',
  PaymentSettings = 'payment-settings',
  CloudStorage = 'cloud-storage',
  Settings = 'settings',
  CommunicationAndPrivacy = 'communication-and-privacy',
  SimcardSettings = 'simcard-settings',
  NetworkSettings = 'network-settings',
  Faq = 'faq',
  SignIn = 'sign-in',
  ChangeBankAccountNumber = 'change-bank-account',
  LimitedUser = 'limited-user',
  ContractTransfer = 'contract-transfer',
  SelectProduct = 'select-product',
}
